<!-- if rightAling is true - we want to add the style space-between to the flex div -->
<div class="w-full flex items-center" [ngClass]="{ 'justify-between': rightAlign() }">
  <span>{{ label() }}</span>
  <input 
    type="number" 
    class="counter-value" 
    [value]="_counterValue" 
    (input)="onInputChange($event)"
    step="any">
</div>
<div class="flex items-center">
  <div class="button-outer">
    <div class="button-wrapper">
      <ion-button mode="md" class="counter-icon" (click)="decrease()">
        <ion-icon slot="icon-only" name="remove"></ion-icon>
      </ion-button>
    </div>
  </div>
  <div class="button-outer">
    <div class="button-wrapper">
      <ion-button mode="md" class="counter-icon" (click)="increase()">
        <ion-icon slot="icon-only" name="add"></ion-icon>
      </ion-button>
    </div>
  </div>
</div>